import { Component, ViewContainerRef, ViewChild, HostListener, ElementRef } from '@angular/core';
import { MatSidenav } from '@angular/material';

import { NativeWindowService } from './services/native-window.service';
import { SocketService } from './services/socket.service';
import { AuthService } from './services/auth.service';
import { DataService } from './services/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
	@ViewChild('sidenav') sidenav: MatSidenav;
	@ViewChild('main') main: ElementRef;
	@HostListener('window:resize') onResize() {
		// guard against resize before view is rendered
		if(this.main){
			this.dataService.getCommon().getNativeWindow().setNativeWidth(this.main.nativeElement.clientWidth);
			this.dataService.getCommon().getNativeWindow().setNativeHeight(this.main.nativeElement.clientHeight);
		}
	}

	public constructor(
		private viewContainerRef: ViewContainerRef, public socketService: SocketService, private authService: AuthService, public dataService: DataService) {
		// You need this small hack in order to catch application root view container ref
		this.viewContainerRef = viewContainerRef;
		this.socketService = socketService;
		this.dataService = dataService;
	}

	ngAfterViewInit() {
		// wait a tick to avoid one-time devMode
		// unidirectional-data-flow-violation error
		setTimeout(_ => {
			this.dataService.getCommon().getNativeWindow().setNativeWidth(this.main.nativeElement.clientWidth);
			this.dataService.getCommon().getNativeWindow().setNativeHeight(this.main.nativeElement.clientHeight);
		});
	}

	manageMenu(type: string){
		switch(type){
			case 'closeMenu':
				this.closeMenu();
				break;
			case 'toggleMenu':
				this.toggleMenu();
				break;
			default:
				this.toggleMenu();
		}
	}

	toggleMenu() {
		//console.log("toggleMenu");
		this.sidenav.toggle();
	}

	closeMenu() {
		//console.log("closeMenu");
		this.sidenav.close();
	}
}
